module.exports = __webpack_public_path__ + "img/logo-SheImage.ccf64118.png";